module.exports = __webpack_public_path__ + "static/media/notification.663a28df.mp3";